<template>
  <div
    v-if="modalIsOpened"
    id="teamInfoModal"
    class="fixed inset-0 w-full bg-black/30 z-51"
  >
    <div
      class="fixed inset-0 overflow-y-auto flex items-start justify-center py-8"
      @click.self="closeModal"
    >
      <div
        class="w-[100vw] max-w-[717px] max-h-[690px] px-[20px] overflow-hidden m-auto"
      >
        <!-- actual modal -->
        <div
          class="h-full mx-auto box-effect rounded-[10px] bg-white overflow-hidden"
        >
          <div
            class="flex flex-col justify-center items-start gap-[22px] p-[20px] pt-[12px]"
          >
            <div class="w-full max-h-[526px] overflow-auto">
              <img v-if="imageUrl" class="w-full"  :src="imageUrl" alt="preview" />
            </div>

            <div class="w-full flex justify-center items-center gap-[10px]">
              <ButtonComponent
                :label="'ปิดหน้าต่าง'"
                :bClass="'btn_shadow--cancel !max-w-[150px]'"
                @clicked="closeModal"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const imageUrl = ref("");
const modalIsOpened = ref(false);

const openModal = (image) => {
  modalIsOpened.value = true;
  document.body.style.overflow = "hidden";

  imageUrl.value = image;
};

const closeModal = () => {
  modalIsOpened.value = false;
  document.body.style.overflow = "auto";
};

defineExpose({ openModal, closeModal });
</script>

<style lang="scss" scoped>
</style>